import { querySelector } from '../functions/querySelectors';
import { DEFAULT_TRANSITION_TIME, U_DN_CLASS, getNaja } from '../config';
import {hideK1Loader, showK1Loader} from "../global/helpers";

window.loaderEnabled = true;
let activeRequests = 0;

let show = function() {
  showK1Loader();
};

let hide = function() {
  hideK1Loader();
};

let enable = function() {
  window.loaderEnabled = true;
};

let disable = function() {
  window.loaderEnabled = false;
};

let getStatus = function() {
  return window.loaderEnabled;
};

const onAjaxStart = function(event) {
  activeRequests++;

  if (activeRequests === 1 && window.loaderEnabled) {
    show();
  }
};

const onAjaxEnd = function(event) {
  activeRequests--;

  if (activeRequests === 0 && window.loaderEnabled) {
    hide();
  }
};

let init = function() {
  getNaja().addEventListener('start', onAjaxStart);
  getNaja().addEventListener('complete', onAjaxEnd);
};

export default {
  show: show,
  hide: hide,
  getStatus: getStatus,
  disable: disable,
  enable: enable,
  init: init
};
